/*
 * ---------------------------------------------------------------------------------
 * Copyright:
 *      NewtonGreen Technologies Pty. Ltd.
 *      Level 4, 175 Scott St.
 *      Newcastle, NSW, 2300
 *      Australia
 * 
 *      E-mail: support@newtongreen.com
 *      Tel: (02) 4925 5288
 *      Fax: (02) 4925 3068
 * 
 *      All Rights Reserved.
 * ---------------------------------------------------------------------------------
 */

/*
 * --------------------------------------------------------------------------------
 * This file contains a function that changes \n's to <br />'s
 * --------------------------------------------------------------------------------
 */

/*
 * ---------------------------------------------------------------------------------
 * Imports - External
 * ---------------------------------------------------------------------------------
 */

/**
 * Required to make use of JSX functionality
 */
import * as React from 'react';

/*
 * ---------------------------------------------------------------------------------
 * Constants
 * ---------------------------------------------------------------------------------
 */

const convertReturnsToHtml = (str: string | null | undefined) => {
    if (!str) {
        return null;
    }

    return str.split('\n')
        .filter(paragraph => paragraph ? true : false)
        .map((paragraph, index, array) => {
            return (
                <span
                    key={index}
                    style={{
                        display: 'block',
                        marginTop: index === 0 ? 0 : 8,
                        marginBottom: index !== array.length - 1 ? 8 : 0
                    }}
                >
                    {paragraph}
                </span>
            )
        });
};

/*
 * ---------------------------------------------------------------------------------
 * Exports - Default
 * ---------------------------------------------------------------------------------
 */
export default convertReturnsToHtml;


// WEBPACK FOOTER //
// ./src/utils/convertReturnsToHtml.tsx